import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import SearchStaff from "../../../components/SearchStaff";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Skeleton from "react-loading-skeleton";

const StaffTab = () => {
  const {
    staffs,
    fetchStaffs,
    fetchDepartments,
    currentPage,
    totalPages,
    handlePrevious,
    handleNext,
    totalRecords,
    isLoading,
    setSelectedStaff,
    selectedStaffIds,
    setSelectedStaffIds,
    selectAll,
    setSelectAll,
    loadingStaffs,
    selectedStaff
  } = useGlobalContext();
  console.log(staffs)

  const [isOpen, setIsOpen] = useState(false);
  const [toggleDrop, setToggleDrop] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);
  const staffDropDown = useRef(null);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedStaffIds([]);
    } else {
      const allStaffIds = staffs?.map((staff) => staff?.staffDetails?.id) || [];
      setSelectedStaffIds(allStaffIds);
    }
    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (id) => {
    setSelectedStaffIds((prev) =>
      prev.includes(id)
        ? prev.filter((staffId) => staffId !== id)
        : [...prev, id]
    );
  };

  const handledrop = () => {
    setToggleDrop(!toggleDrop);
  };

  useEffect(() => {
    // Initial data fetch
    if (!staffs || staffs.length === 0) {
      fetchStaffs();
      fetchDepartments();
    }
  }, []);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
      if (staffDropDown.current && !staffDropDown.current.contains(e.target)) {
        setToggleDrop(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    setSelectAll(
      staffs?.length > 0 && selectedStaffIds?.length === staffs?.length
    );
  }, [selectedStaffIds, staffs]);

  if (loadingStaffs) {
    return (
      <div className="mt-[20px] staff-tab">
        <HeaderSkeleton />
        <TableSkeleton />
        <PaginationSkeleton />
      </div>
    );
  }

  return (
    <div className="mt-[20px] staff-tab">
      <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between items-start xl:items-center gap-[15px] lg:gap-[0px]">
        <SearchStaff
          dropdownRef={dropdownRef}
          setDropdownOpen={setDropdownOpen}
          toggleDropdown={() => setDropdownOpen(!isDropdownOpen)}
          isDropdownOpen={isDropdownOpen}
        />

        <div className="flex justify-between lg:justify-start gap-[15px] mt-[0] setup-tab">
          <div className="inline-block relative text-left">
            <button
              type="button"
              onClick={handledrop}
              className="inline-flex justify-center items-center gap-x-1.5 shadow-sm rounded-md w-full text-white text-sm second-btn"
            >
              Add Staff
              <svg
                className="-mr-1 w-5 h-5 text-gray-400"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {toggleDrop && (
              <div
                ref={staffDropDown}
                className="right-0 left-[0] lg:left-[-96px] xl:left-[-96px] z-10 absolute bg-white ring-opacity-5 shadow-lg mt-2 rounded-md focus:outline-none divide-y divide-gray-100 ring-1 ring-black w-56 origin-top-right staff-page-res"
              >
                <div className="py-1">
                  <Link
                    to="/add-one-staff"
                    className="block px-4 py-2 text-gray-700 text-sm"
                  >
                    Add One Staff
                  </Link>
                  <Link
                    to="#"
                    className="block px-4 py-2 text-gray-700 text-sm"
                  >
                    Add Multiple Staff
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="flex shadow mt-4 p-0 border border-1 rounded-md w-[100%] h-[100%] overflow-x-auto overflow-y-auto">
        <table className="table-section border border-[#dcdbdb] rounded-lg w-full overflow-hidden table-auto">
          <thead className="top-0 sticky bg-white shadow-md border-gray-300">
            <tr>
              <th className="p-3 border-[#dbdbdb] border-r">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
              </th>
              <th className="p-3 border-[#dbdbdb] border-r">Name</th>
              <th className="p-3 border-[#dbdbdb] border-r">Job Title</th>
              <th className="p-3 border-[#dbdbdb] border-r">Employee Id</th>
              <th className="p-3 border-[#dbdbdb] border-r">Employee Type</th>
              <th className="p-3 border-[#dbdbdb] border-r">Date of Joining</th>
              <th className="p-3 border-[#dbdbdb] border-r">Date of Birth</th>
              <th className="p-3 border-[#dbdbdb] border-r">Mobile Number</th>
              <th className="p-3 border-[#dbdbdb] border-r">
                Personal Email ID
              </th>
              <th className="p-3 border-[#dbdbdb] border-r">Marital Status</th>
              <th className="p-3 border-[#dbdbdb] border-r">Gender</th>
              <th className="p-3 border-[#dbdbdb] border-r">Current Address</th>
              <th className="p-3 border-[#dbdbdb] border-r">Aadhaar</th>
              <th className="p-3 border-[#dbdbdb] border-r">Pan</th>
              <th className="p-3 border-[#dbdbdb] border-r">
                Auth Token
              </th>
              <th className="p-3 border-[#dbdbdb] border-r">Guardian Name</th>
              <th className="p-3 border-[#dbdbdb] border-r">
                Emergency Contact
              </th>
            </tr>
          </thead>

          <tbody>
            {loadingStaffs && !staffs && (
              <tr className="h-[100px]">
                <td
                  colSpan="11"
                  className="py-4 font-semibold text-gray-600 text-xl text-center"
                >
                  <ClipLoader color="#27004a" size={50} />
                </td>
              </tr>
            )}
            {!loadingStaffs &&
              staffs &&
              staffs?.map((staff, index) => (
                <tr key={index} className="hover:bg-gray-50 border">
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    <input
                      type="checkbox"
                      checked={selectedStaffIds?.includes(
                        staff?.staffDetails?.id
                      )}
                      onChange={() =>
                        handleCheckboxChange(staff?.staffDetails?.id)
                      }
                    />
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    <Link
                      to={`/personal-detail/${staff?.id}`}
                      onClick={() => setSelectedStaff(staff)}
                      className="font-medium text-[#8A25B0] hover:underline"
                    >
                      {staff?.name || "N/A"}
                    </Link>
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.job_title || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.employee_id || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.employee_type || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.date_of_joining
                      ? new Date(
                          staff.staffDetails.date_of_joining
                        ).toLocaleDateString()
                      : "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.date_of_birth
                      ? new Date(staff?.staffDetails?.date_of_birth).toLocaleDateString()
                      : "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.mobile || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.email || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.marital_status || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.gender || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.current_address || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.staff_bg_verification?.aadhaar_number || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.staff_bg_verification?.pan_number || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.login_otp || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.guardian_name || "N/A"}
                  </td>
                  <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
                    {staff?.staffDetails?.emergency_contact_mobile || "N/A"}
                  </td>
                </tr>
              ))}

            {!loadingStaffs && staffs && staffs?.length === 0 && (
              <tr>
                <td
                  colSpan="11"
                  className="py-4 font-semibold text-gray-600 text-xl text-center"
                >
                  No Staff Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-[14px] xl:pr-0 pb-[0] xl:pl-0 w-[100%]">
        <p className="text-[#a5a1a1] text-[14px]">
          Total Records: {totalRecords}
        </p>
        <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md pagination">
          <button
            onClick={handlePrevious}
            disabled={currentPage === 1}
            className={`pt-2 pb-[8px] text-[12px] ${
              currentPage === 1 ? "opacity-40" : ""
            }`}
          >
            Previous
          </button>
          <span className="flex items-center bg-[#27004a] pr-3 pl-3 text-[12px] text-white">
            {currentPage}
          </span>
          <button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className={`pt-2 pb-[8px] text-[12px] ${
              currentPage === totalPages ? "opacity-40" : ""
            }`}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export const HeaderSkeleton = () => (
  <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between items-start xl:items-center gap-[15px] lg:gap-[0px]">
    <div className="w-full xl:w-1/2">
      <Skeleton height={40} className="mb-2" />
    </div>
    <div className="w-[120px]">
      <Skeleton height={40} />
    </div>
  </div>
);

// Skeleton for table row
export const TableRowSkeleton = () => (
  <tr className="border">
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton circle width={16} height={16} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={120} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={100} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={80} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={90} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={100} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={100} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={110} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={150} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={90} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={80} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={150} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={100} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={100} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={120} />
    </td>
    <td className="p-[10px] border-[#dbdbdb] border-r whitespace-nowrap">
      <Skeleton width={120} />
    </td>
  </tr>
);

// Skeleton for pagination section
export const PaginationSkeleton = () => (
  <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-[14px] xl:pr-0 pb-[0] xl:pl-0 w-[100%]">
    <div>
      <Skeleton width={150} />
    </div>
    <div className="flex gap-2">
      <Skeleton width={80} height={30} />
      <Skeleton width={40} height={30} />
      <Skeleton width={80} height={30} />
    </div>
  </div>
);

// Main table skeleton component
export const TableSkeleton = () => (
  <div className="flex shadow mt-4 p-0 border border-1 rounded-md w-[100%] h-[100%] overflow-x-auto overflow-y-auto">
    <table className="table-section border border-[#dcdbdb] rounded-lg w-full overflow-hidden table-auto">
      <thead className="top-0 sticky bg-white shadow-md border-gray-300">
        <tr>
          {[...Array(16)].map((_, index) => (
            <th key={index} className="p-3 border-[#dbdbdb] border-r">
              <Skeleton
                width={index === 0 ? 16 : 100}
                height={index === 0 ? 16 : 20}
              />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {[...Array(5)].map((_, index) => (
          <TableRowSkeleton key={index} />
        ))}
      </tbody>
    </table>
  </div>
);

export default StaffTab;
